module.exports = __webpack_public_path__ + "img/pub1.f4eb8c29.png";